import { basePropertiesSchema } from '../base-schema-properties'

export default {
  $schema: 'http://json-schema.org/draft-07/schema#',
  title: 'Portal',
  description: 'Displays another page editor block selected by UUID',
  type: 'object',
  required: ['targetBlockUuid'],
  properties: {
    ...basePropertiesSchema,
    targetBlockUuid: {
      title: 'Target block UUID',
      description:
        'UUID of the block to display. A Portal cannot display another Portal.',
      type: 'string',
      pattern:
        '^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$',
    },
  },
}
